import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { PricingPage } from '../../features/marketing/pages/PricingPage';

export const Route = createFileRoute('/$lang/pricing')({ component: Page });

function Page(): ReactNode {
  const { lang } = Route.useParams();
  return <PricingPage lang={lang} />;
}
